import React from 'react';
import {Button, Grid, GridColumn, IButtonProps, ICheckProps, ITextFieldProps, TextField} from '../../components';
import classNames from 'classnames';
import Datepicker, {IDatepickerSingleProps} from '../../components/forms/datepicker/datepicker';

export interface ITemplateSignUpProps {
    title: string,
    button: IButtonProps;
    textFields: ITextFieldProps[];
    calendarField?: IDatepickerSingleProps;
    check?: ICheckProps;
    className?: string;
    onSubmit?: () => void;
    tutorials?: ISignUpTutorialsProps;
}

export interface ISignUpTutorialsProps {
    label: string;
    link: JSX.Element;
}

const TemplateSignUp = (props: ITemplateSignUpProps): JSX.Element => {
    const className: string = classNames(
        'login-form',
        props.className,
    );

    const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();
        if (props.onSubmit) {
            props.onSubmit();
        }
    };

    return (
        <form className={className} onSubmit={onSubmit}>
            <div className="text text-center text--triple">
                <h1 className="h2">{props.title}</h1>
                <div className="text">
                    {props.textFields.map((el: ITextFieldProps, i: number) => <TextField {...el} key={i} isStatic={true} iconSize="small" />)}
                    {props.calendarField && <Datepicker {...props.calendarField} className="text-left"/>}
                    <Button {...props.button} block={true} />
                    {props.tutorials &&
                        <Grid justify={['between-xs']}>
                            <GridColumn className="text-left" width={['max-xs']}>
                                {props.tutorials.label}
                            </GridColumn>
                            <GridColumn width={['min-xs']}>
                                {props.tutorials.link}
                            </GridColumn>
                        </Grid>
                    }
                    <button type='submit' style={{display: 'none'}}/>
                </div>
            </div>
        </form>
    );
};

export default TemplateSignUp;
